import axios from "axios";
import * as types from "../mutation-types";
import api from "../../api/api";

export const state = {
  pagination: {
    from: 0,
    to: 0,
    totalPage: 0,
    path: "",
    currentPage: 0,
    totalRecord: 0,
    perPage: 0
  },
  additionalTimeSheets: [],
  additionalTimeSheet: {},
  totalTimeSheetRequests: []
};

// getters
export const getters = {
  pagination: state => state.pagination,
  additionalTimeSheets: state => state.additionalTimeSheets,
  additionalTimeSheet: state => state.additionalTimeSheet,
  totalTimeSheetRequests: state => state.totalTimeSheetRequests,
};

// mutations
export const mutations = {
  [types.ADDITIONAL_TIMESHEET.FETCH_TOTAL_ADDITIONAL_TIMESHEET_REQUEST](state, totalTimeSheetRequests) {
    state.totalTimeSheetRequests = totalTimeSheetRequests;
  },
  [types.ADDITIONAL_TIMESHEET.SHOW_ADDITIONAL_TIMESHEET](
    state,
    additionalTimeSheet
  ) {
    state.additionalTimeSheet = additionalTimeSheet;
  },
  [types.ADDITIONAL_TIMESHEET.FETCH_ADDITIONAL_TIMESHEET](
    state,
    additionalTimeSheets
  ) {
    state.additionalTimeSheets = additionalTimeSheets;
    state.pagination.from = additionalTimeSheets.from;
    state.pagination.to = additionalTimeSheets.to;
    state.pagination.totalPage = additionalTimeSheets.last_page;
    state.pagination.path = additionalTimeSheets.path;
    state.pagination.currentPage = additionalTimeSheets.current_page;
    state.pagination.totalRecord = additionalTimeSheets.total;
    state.pagination.perPage = additionalTimeSheets.per_page;
  }
};

// actions
export const actions = {
  async detailOverTimeRequest({ commit }, additionalTimeSheetId) {
    const response = await axios.get(
      api.SHOW_ADDITIONAL_TIMESHEET + "/" + additionalTimeSheetId
    );
    commit(types.ADDITIONAL_TIMESHEET.SHOW_ADDITIONAL_TIMESHEET, response.data);
  },

  async fetchAdditionalTimeSheet({ commit }, payload) {
    const response = await axios.get(api.LIST_ADDITIONAL_TIMESHEET, {
      params: {
        per_page: payload.itemsPerPage,
        page: payload.currentPage,
        start_date: payload.start_date,
        end_date: payload.end_date,
        status: payload.status,
        foot_code: payload.foot_code,
        division_code: payload.division_code,
        employee_info: payload.employee_info,
        approve_person: payload.approvePerson
      }
    });
    commit(
      types.ADDITIONAL_TIMESHEET.FETCH_ADDITIONAL_TIMESHEET,
      response.data.timeSheetRequests
    );
    commit(
      types.ADDITIONAL_TIMESHEET.FETCH_TOTAL_ADDITIONAL_TIMESHEET_REQUEST,
      response.data.totalTimeSheetRequests
    );
  },

  // eslint-disable-next-line
  async deleteAdditionalTimeSheet({ commit }, overTimeRequestId) {
    await axios.delete(
      api.DELETE_ADDITIONAL_TIMESHEET + "/" + overTimeRequestId
    );
  }
};
